import React, { useState, useEffect } from 'react'
import Loading from '../Commons/Loading/Loading';
import FooterFormulario from '../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import '../Divisiones/DivisionesDetalles.scss'
import { Modal } from 'react-bootstrap'
import ObraThumb from '../Commons/ObraThumb/ObraThumb';
import ObrasRealizadas from '../Commons/ObrasRealizadas/ObrasRealizadas';


const Tanque320m3 = () => {


    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };

    const handleShow = (paramUrl, paramDesc) => {

        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)

        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    })

    if (loading) { return <Loading /> }

    return (

        <section className='container-fluid p-0 containerBlock' >


            <Modal
                show={show}
                size='lg'
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reparación Tanqueaa 160 m³</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
                </Modal.Body>

                <Modal.Footer>
                    <small >{txtDes}</small>
                </Modal.Footer>

            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-obras-civiles.jpg"
                    alt="Obras, andamios."
                    loading='lazy'
                    className='divisionItem__container--img'
                />

                <div className='divisionItem__container--textos divisionItem__container--textos-obras' >
                    <h3 className='divisionItem__container--header'>OBRAS</h3>
                    <h1 className='divisionItem__container--title'>Construccion de tanque</h1>
                </div>

            </div>

            <div className='container-fluid obrasItem__detail'>
                <div className='container animated fast fadeIn'>
                    <Link to={'/obras/'}>
                        <small>
                            <i className="fas fa-angle-double-left" style={{ 'paddingBottom': '15px', 'paddingRight': '10px' }} ></i>
                            Volver a Obras
                        </small>
                    </Link>

                    <div className='row'>

                        <div className='col-md-6'>
                            <img
                                src="../images/obras/tanque-320m3/tanque-320m3-00.jpg"
                                alt="Reparación Tanque 160 m³."
                                className='d-block w-100 divisionItem__detail--header'
                                loading='lazy'
                            />
                        </div>

                        <div className='col-md-6 divisionItem__detail--block'>
                            <h1 className='divisionItem__detail--title' >Tanque con capacidad<br />320 m3</h1>
                            <h3 className='divisionItem__detail--subtitle' >Construcción de tanque bajo norma API 650</h3>

                            <p className='divisionItem__detail--text pt-2' >
                                <strong>Ubicación:</strong> Golfo San Jorge – Chubut<br /><br />
                                Posee un diámetro de 9100 mm y una altura de 50000 mm..<br />
                                Cuenta con escalera helicoidal. .<br />
                                Plataforma sobre techo en todo su perímetro y protecciones laterales (Rodapie y guardarodilla) y pasamanos.

                            </p>

                        </div>

                    </div>

                    <div className='row obras__box'>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'270'}
                                ObraVal={'m2'}
                                ObraItem={''}
                                ObraDet={'Pintura'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'400'}
                                ObraVal={'m'}
                                ObraItem={'Lineales'}
                                ObraDet={'Soldadura'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraXL={true}
                                ObraNum={'1500'}
                                ObraVal={'m2'}
                                ObraNum1={'87500'}
                                ObraVal1={'Kg'}
                                ObraItem={''}
                                ObraDet={'Chapas'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'145'}
                                ObraVal={'m2'}
                                ObraItem={''}
                                ObraDet={'Aislación (chapa trapezoidal)'}
                            />
                        </div>
                    </div>

                    <div className='gallery__cont'>

                        <div className='gallery__cont--column25'>
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-01.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-01.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-02.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-02.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-03.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-03.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column25'>
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-04.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-04.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-05.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-05.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column25'>
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-06.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-06.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-07.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-07.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-08.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-08.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-09.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-09.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column25'>
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-10.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-10.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-11.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-11.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-12.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-12.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-320m3/tanque-320m3-13.jpg', 'Reparación Tanque 160 m³')} src='../images/obras/tanque-320m3/tanque-320m3-13.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>



                    </div>
                </div>
            </div>
            <div className='otrasObras__container'>
                <ObrasRealizadas cantObras={5} excluir={1} />
            </div>
            <FooterFormulario className='mt-5' />
        </section>
    )
}

export default Tanque320m3